import { render, staticRenderFns } from "./TopicApproval.vue?vue&type=template&id=7444f15e&scoped=true"
import script from "./TopicApproval.vue?vue&type=script&lang=js"
export * from "./TopicApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7444f15e",
  null
  
)

export default component.exports